import React, { createContext } from "react";
import { logDebug, logError, getErrorLogs, clearErrorLogs } from "../utils/logger";

export const LoggerContext = createContext({
	logDebug: () => {},
	logError: () => {},
	getErrorLogs: () => [],
	clearErrorLogs: () => {},
});

export const LoggerProvider = ({ children }) => {
	const logger = { logDebug, logError, getErrorLogs, clearErrorLogs };

	return <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>;
};
